// App heights
const doc = document.documentElement
const appHeights = () => {
	let windowHeight = $(window).height();
	doc.style.setProperty("--app-height", windowHeight + "px");
}
appHeights();

$(window).on("resize", function () {
	appHeights();
});

window.addEventListener("load", (event) => {
	appHeights();
});


document.addEventListener('DOMContentLoaded', () => {
	let votes = [];

	for (var i = 0; document.getElementById('option' + (i + 1)); i++) {
		const option = document.getElementById('option' + (i + 1));
		votes.push(+option.getAttribute('num'));
	}

	function updateBars() {
		const totalVotes = votes.reduce((accumulator, currentValue) => {
			return accumulator + currentValue;
		}, 0);

		for (var i = 0; document.getElementById('option' + (i + 1)); i++) {
			const option = document.getElementById('option' + (i + 1));
			const percent = totalVotes ? (votes[i] / totalVotes) * 100 : 0;
			const bar = option.querySelector('.golosovalka-screen__results-item-bar');
			const percentage = option.querySelector('.golosovalka-screen__results-item-percentage');
			bar.style.width = `calc(24px + ${percent}% * (100 - 24) / 100)`;
			percentage.textContent = `${percent.toFixed(1)}%`;
		}
	}

	updateBars();

	function fetchVotes() {
		$.ajax({
			url: "/ajax.php?mid=117",
			type: 'POST',
			dataType: "json",
			data: {
				numOnline: $("#voteNumOnline").val(),
			},
			success: (res) => {
				votes = res['votes'].map(function (num) {
					return parseInt(num, 10);
				});
				updateBars();
			},
			error: (err) => {
				console.log(err);
			}
		});
	}

	setInterval(fetchVotes, 5000);
});
